import { CircleProps } from './svg';

export type Quartile = 0 | 1 | 2 | 3;
export type DateFrequency = 'd' | 'w' | 'M';
export type GraphElement<T> = React.ComponentClass<T> | React.SFC<T> | string;

export type QuartileCallback = (quartile: any[]) => void;

export interface GraphProps {
  axisPadding?: number;
  className?: string;
  data: any[];
  height?: number;
  memberPadding?: number;
  showAxis?: boolean;
  TooltipComponent?: GraphElement<any>;
  tooltipProps?: (d: any) => any;
  width?: number;
  activeEntityName?: string;
  entityType?: string;
}

export interface QuartileLegendProps {
  data: any[];
  quartile: Quartile;
  isActive: boolean;
  width: number;
}

export interface HistogramProps extends GraphProps {
  QuartileLegend?: GraphElement<QuartileLegendProps>;
  domain?: [number, number];
  isFocused?: (d: any) => boolean;
  quartileHovered?: QuartileCallback;
  quartileUnhovered?: QuartileCallback;
  showLegend?: boolean;
  thresholds?: number[];
  value?: (d: any) => number;
}

export interface GraphElementProps {
  className: string;
  data: any;
  focused: boolean;
  muted: boolean;
}

export interface HistogramElementProps extends GraphElementProps {
  quartile: Quartile;
}

export interface DotProps extends HistogramElementProps, CircleProps {}

export interface DotWrapperProps extends DotProps {
  children: any;
}

export interface DotHistogramProps extends HistogramProps {
  DotComponent?: GraphElement<DotProps>;
  DotWrapper?: GraphElement<DotWrapperProps>;
}

export interface BarProps extends HistogramElementProps {
  height: number;
  width: number;
}

export interface BarWrapperProps extends BarProps {
  children: any;
}

export interface BarHistogramProps extends HistogramProps {
  BarComponent?: GraphElement<BarProps>;
  BarWrapper?: GraphElement<BarWrapperProps>;
}
